import { n as __reExport, t as __exportAll } from "./rolldown-runtime-BBjsoOtd.mjs";
export * from "@shikijs/engine-oniguruma";
//#region src/engine-oniguruma.ts
var engine_oniguruma_exports = /* @__PURE__ */ __exportAll({});
import * as import__shikijs_engine_oniguruma from "@shikijs/engine-oniguruma";
__reExport(engine_oniguruma_exports, import__shikijs_engine_oniguruma);
//#endregion
export { engine_oniguruma_exports as t };
